import { Code } from "lucide-react";

interface Props {
  label?: string | null;
  className?: string;
}

/** Eye-catching chip for a job's tech-stack tag (e.g. "mern") — same pulse/glow
 * treatment as TimeAgoChip but a distinct dark indigo tint, so it doesn't get lost
 * among plain-text metadata on the card and doesn't read as the same chip as TimeAgoChip. */
export default function TechTagChip({ label, className }: Props) {
  if (!label) return null;

  return (
    <span
      className={`flex items-center gap-1 text-[10px] px-2 py-1 rounded-full font-inter font-bold text-white bg-gradient-to-r from-indigo-900 to-slate-950 ring-2 ring-indigo-400/40 shadow-[0_0_10px_rgba(129,140,248,0.5)] animate-pulse cursor-default shrink-0 ${className ?? ""}`}
    >
      <Code className="w-3 h-3" />
      {label}
    </span>
  );
}
